import type { AnalyticsEventParamsType } from '@repo/analytics';
import { toGa4EventName } from './ga4-event-map';
import { gtmDataLayerAdapter } from './gtm-data-layer-adapter';

export function trackEvent(eventName: string, params?: AnalyticsEventParamsType): void {
  if (typeof window === 'undefined') {
    return;
  }
  gtmDataLayerAdapter.track(toGa4EventName(eventName), params);
}
